import { useContext, useEffect, useState } from "react"
import { Link, useLocation } from "react-router-dom"
import styles from "../css/payments/trial-end-banner.module.css"
import { ReactComponent as XIcon } from "../../images/X.svg"
import { getDaysToTrialEnd } from "../../helpers/CalendarHelper"
import { CurrentMetadataForUser } from "../../context/CurrentMetadataForUser"

export const TrialEndBanner = ({ onClose }) => {
    const { trialEnd } = useContext(CurrentMetadataForUser)
    const [numDaysLeft, setNumDaysLeft] = useState();
    const [isBannerDisplayed, setIsBannerDisplayed] = useState();
    const location = useLocation();

    const getBannerText = () => {
        if (numDaysLeft === 0) {
            return "Trial ends today"
        }
        else if (numDaysLeft > 1) {
            return `${numDaysLeft} days left in trial`
        }
        else if (numDaysLeft === 1) {
            return "1 day left in trial"
        }
        else {
            return ''
        }
    }

    useEffect(() => {
        if (trialEnd) {
            const daysLeft = getDaysToTrialEnd(trialEnd);
            setNumDaysLeft(daysLeft);
            let displayBanner = true;
            // We're doing a very explicit check because 0 is falsy, null is treated as 0 with isNaN
            if (daysLeft === null || daysLeft === undefined
                || daysLeft > 2 || daysLeft < 0
                || location.pathname.includes('pricing')
                || location.pathname.includes('renew-subscription')
                || location.pathname.includes('take-a-flow')
            ) {
                displayBanner = false;
            }

            setIsBannerDisplayed(displayBanner)
        }
    }, [trialEnd, location])

    return (
        isBannerDisplayed ?
            <div className={styles.banner} >
                <XIcon className={styles.xIcon} onClick={onClose} />
                <p className={styles.text}>
                    <span className={styles.hourglass}>⏳</span>
                    <span>{getBannerText()}</span>
                </p>
                {/* Desktop Button (in header)*/}
                <Link className={`${styles.button} ${styles.buttonDesktop}`} to="/pricing">
                    Keep Flowing
                </Link>
                {/* Mobile Button (fixed position at bottom)*/}
                <Link className={`${styles.button} ${styles.buttonMobile}`} to="/pricing">
                    Keep me supported 💛
                </Link>
            </div>
            : null
    )
}
